import { Div } from "./ShopPage.styled";
import ShpoCategory from "../../components/ShopCategory/ShopCategory"
const ShopPage = () => {
    return (<Div>
        <ShpoCategory></ShpoCategory>
    </Div>);
}
 
export default ShopPage;